import ServiceRecommendation from "./types/ServiceRecommendation";

/**
 * ProductRecommendation
 *
 * Wrapper component that renders a specific recommendation type.
 * Its meant to be used inside right side of Hybrid template pages( templates used as public and private )
 *
 */
function ProductRecommendation() {
  return <div className="pr-card-container">{<ServiceRecommendation />}</div>;
}

export default ProductRecommendation;
